import * as THREE from 'three';
import gsap from 'gsap';
import { scene, group } from './Scene';
import { camera } from './Camera';

const audioCache = {};

let listener, bgm;
const audioLoader = new THREE.AudioLoader();

export const SetAudioListener = () => {
    listener = new THREE.AudioListener();
    camera.add(listener);

    return listener;
}

export const InitAudio = () => {
    SetBGM();
    SetPositinalAudio('a_select_figure.wav', new THREE.Vector3(-0.2, 0.05, 0.2), 0.5, 1, 10);
    SetPositinalAudio('b_ambient_master.wav', new THREE.Vector3(0.1, 0.2, 0), 0.5, 1, 10);
}

export const SetMute = (_isOn) => {
    if (!listener) {
        console.error('Audio listener is not initialized.')
        return;
    }

    if (_isOn) { // 음소거
        listener.gain.gain.setValueAtTime(0, listener.context.currentTime);
    }
    else { // 음소거 해제
        listener.gain.gain.setValueAtTime(1, listener.context.currentTime);
    }
}

const SetBGM = (_isPlay) => {
    if (!listener) {
        console.error('Audio listener is not initialized.')
        return;
    }

    bgm = new THREE.Audio(listener);
    audioLoader.load(
        `${process.env.PUBLIC_URL}/data/audio/bgm.wav`,
        (buffer) => {
            bgm.setBuffer(buffer);
            bgm.setLoop(true);
            bgm.setVolume(0.2);
            bgm.play();

            audioCache['bgm.wav'] = bgm;
        },
        undefined,
        (err) => {
            console.error('BGM load error', err);
        }
    )
}

const SetPositinalAudio = (_filename, _position = new THREE.Vector3(0, 0, 0), _min = 0.1, _max = 0.15, _factor = 3) => {
    if (!listener) {
        console.error('Audio listener is not initialized.')
        return;
    }
    const box = new THREE.Object3D();
    group.add(box);

    box.position.copy(_position);

    const sound = new THREE.PositionalAudio(listener);
    audioLoader.load(
        `${process.env.PUBLIC_URL}/data/audio/${_filename}`,
        (buffer) => {
            sound.setBuffer(buffer);
            sound.setLoop(true);

            sound.setRefDistance(_min);          // 가까울 때 볼륨이 최대로 들리는 거리
            sound.setMaxDistance(_max);         // 이 거리 이상 떨어지면 거의 안 들림
            sound.setRolloffFactor(_factor);      // 거리 감쇠 강도
            sound.setDistanceModel('inverse'); // 감쇠 방식

            box.add(sound);

            // const rangeHelper = new THREE.Mesh(
            //     new THREE.SphereGeometry(_max, 16, 16), // ← sound.setMaxDistance() 값과 동일하게
            //     new THREE.MeshBasicMaterial({
            //         color: 0x00ff00,
            //         wireframe: true,
            //         transparent: true,
            //         opacity: 1
            //     })
            // );
            // rangeHelper.name = `${_filename}_range`;
            // box.add(rangeHelper);  // box와 함께 움직이게

            sound.play();
        },
        undefined,
        (err) => {
            console.error(`${_filename} load error`, err);
        }
    )
}

export const SetAudio = (_filename, _isOneTime = false) => {
    if (!listener) {
        console.error('Audio listener is not initialized.')
        return;
    }
    let sound;

    if (_isOneTime) {
        sound = new THREE.Audio(listener); // Do not cache one-time sounds
    } else {
        if (audioCache[_filename]) {
            sound = audioCache[_filename];
        } else {
            sound = new THREE.Audio(listener);
            audioCache[_filename] = sound;
        }
    }

    const playSound = (buffer) => {
        sound.setBuffer(buffer);
        sound.setVolume(0.5);
        sound.play();

        if (_isOneTime) {
            sound.source.onended = () => {
                if (sound.isPlaying) {
                    sound.stop();
                }
                if (sound.parent) {
                    sound.parent.remove(sound);
                }
                sound.disconnect();
            };
        } else {
            sound.setLoop(true);
        }
    };

    if (sound.buffer) {
        playSound(sound.buffer);
    } else {
        audioLoader.load(
            `${process.env.PUBLIC_URL}/data/audio/${_filename}`,
            (buffer) => {
                if (!_isOneTime) {
                    sound.setBuffer(buffer);
                }
                playSound(buffer);
            },
            undefined,
            (err) => {
                console.error('Audio load error', err);
            }
        );
    }
}
export const RemoveAudio = (_filename) => {
    const sound = audioCache[_filename];
    if (sound) {
        if (sound.isPlaying) {
            sound.stop();
        }
        if (sound.parent) {
            sound.parent.remove(sound);
        }
        sound.disconnect();
        delete audioCache[_filename];
        console.log(`Audio '${_filename}' removed from cache.`);
    } else {
        console.warn(`Audio '${_filename}' not found in cache.`);
    }
}